import { Box, CircularProgress, Dialog, Typography } from '@mui/material'

interface IProps {
  open: boolean
}

const LoadConfirmationProcessing = ({ open }: IProps) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 2,
          px: 4,
          py: 6,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <CircularProgress size={56} thickness={4} />
        <Typography variant="h6" fontWeight={700} color="text.primary">
          Load confirmation is processing
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
          Please wait while we process your load confirmation.
          <br />
          This may take a few moments.
        </Typography>
      </Box>
    </Dialog>
  )
}

export default LoadConfirmationProcessing
